// extracted by mini-css-extract-plugin
module.exports = {"Error":"Error__1P5oa"};